import { render } from "./RegisterFree.vue?vue&type=template&id=737ad15a&scoped=true"
import script from "./RegisterFree.vue?vue&type=script&lang=js"
export * from "./RegisterFree.vue?vue&type=script&lang=js"

import "./RegisterFree.vue?vue&type=style&index=0&id=737ad15a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737ad15a"]])

export default __exports__